import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent, setModalContentProps, } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { deleteFaqCategory } from '../../../api/admin/faq';
import { removeCategory } from '../../../store/adminSlices/faq';
const ConfirmDeleteFaqCategory = ({ categoryUid }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [state, setState] = useState('idle');
    const closeModal = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
        dispatch(setModalContentProps(null));
    };
    const handleConfirm = async () => {
        setState('pending');
        try {
            await deleteFaqCategory(categoryUid);
            dispatch(removeCategory(categoryUid));
            closeModal();
        }
        catch (err) {
            const axiosErr = err;
            if (axiosErr?.response?.status === 409) {
                // faq_category_not_empty — transition body in place, do NOT close
                // and do NOT remove the category from the slice.
                setState('error409');
                return;
            }
            // Any other failure → generic error modal (D-23). Clear the previous
            // modal's content props (WR-02 defense-in-depth) so the SomethingWentWrong
            // modal cannot silently inherit { categoryUid } from this delete flow if
            // a future refactor starts reading modalContentProps for it.
            dispatch(setModalContentProps(null));
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    if (state === 'error409') {
        return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.faq.delete_category_not_empty.title'), type: 'h1' }) }), _jsx("p", { children: t('admin.faq.delete_category_not_empty.body') }), _jsx("div", { className: "modal-content-button", children: _jsx(ButtonsGroup, { justify: 'center', children: _jsx(Button, { label: t('button.ok'), onClick: closeModal }) }) })] }));
    }
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.faq.confirm_delete_category'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: closeModal, disabled: state === 'pending' }), _jsx(Button, { variant: 'outlined', label: t('button.delete_category'), onClick: handleConfirm, disabled: state === 'pending' })] }) })] }));
};
export default ConfirmDeleteFaqCategory;
